import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Herbals = () => {
    const rawHtml = `
        <style>
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
        </style>
        <div id="wrapper">
            <Header />
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <h2 class="display-3 fw-bold color all-ts">Herbal <span class="underliner nocolor viewport-detect" data-delay="1000">Products</span></h2>
                            <p>Explore our range of herbal products for holistic wellness and care.</p>
                            <a href="#herbal-products" class="button py-3 px-4 bg-color-2 color h-bg-color h-text-light rounded mx-0">View Herbals<i class="bi-arrow-right ms-2 me-0"></i></a>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Herbals" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Herbals" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Herbals" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="content">
                <div class="content-wrap py-0">
                    <div id="herbal-products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Our Herbal Product Range</h2>
                                    <p>Discover our comprehensive range of herbal solutions for health and wellness.</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#herbal-products-table">
                                                    <i class="bi bi-flower1 me-2"></i>Herbal Products
                                                </button>
                                            </h2>
                                            <div id="herbal-products-table" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr><th>PRODUCT COMPOSITION</th><th>PACKAGING</th></tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Herbal Hair Oil</td><td>250/400/500 ml</td></tr>
                                                                <tr><td>Herbal Shampoo</td><td>100/200 ml</td></tr>
                                                                <tr><td>Herbal Hair Conditioner</td><td>175/200 ml</td></tr>
                                                                <tr><td>Aloe vera/Neem Shampoo</td><td>100/200 ml</td></tr>
                                                                <tr><td>Amla Hair Oil</td><td>250/400/500 ml</td></tr>
                                                                <tr><td>Herbal Soaps (Aloe vera/Neem/Charcoal/Others)</td><td>75 gm</td></tr>
                                                                <tr><td>Herbal Cough Syrup</td><td>100 ml</td></tr>
                                                                <tr><td>Ashwagandha Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Menstrual Discomfort Relief Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Cardiovascular Support Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Memory & Concentration enhancer Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Virility Enhancement Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Mood Enhancement Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Sexual Stimulant Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Tulsi Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Take Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Brahmi Capsules</td><td>10x10</td></tr>
                                                                <tr><td>Shilajit Capsules</td><td>10x10</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default Herbals; 